<template>
	<Popup
		v-model="selfDisplay"
		title="管理员"
		:confirmBtnDisplay="false"
	>
		<div v-loading="loading" style="padding: 15px;">
			<!-- 表格 -->
			<div class="base_table">
				<el-table
					:data="tabData"
					style="width: 100%"
				>
					<el-table-column
						prop="code"
						label="账号"
					>
					</el-table-column>
					<el-table-column
						prop="name"
						label="姓名"
					>
					</el-table-column>
					<el-table-column
						prop="phone"
						label="手机"
					>
					</el-table-column>
					<el-table-column
						prop="identify"
						label="身份"
					>
					</el-table-column>
				</el-table>
			</div>
			<!-- 表格 end -->
		</div>
	</Popup>
</template>

<script>
	import Api from "../../../../../api/index.js"
	
	export default {
		model: {
			prop: 'display',
			event: 'changeDisplay'
		},
		props: {
			display: Boolean,
			id: {
				type: [Number, String],
				required: true
			}
		},
		mounted () {
			this.display && (this.selfDisplay = true);
		},
		data () {
			return {
				loading: false,
				selfDisplay: false,
				tabData: []
			}
		},
		methods: {
			getData () {
				const that = this;
				that.loading = true;
				var _requestData = {
					uId: that.id
				};
				that.tabData = [];
				Api.findOrganizationManager(_requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						res.data.data.forEach((v) => {
							var _identify = '';
							switch (parseInt(v.ucategory)) {
								case 1:
									_identify = '后台用户';
									break;
								case 2:
									_identify = '代理商';
									break;
								case 3:
									_identify = '医生';
									break;
								case 4:
									_identify = '医生助理';
									break;
							}
							that.tabData.push({
								code: v.ucode,
								name: v.uname,
								phone: v.uphone,
								identify: _identify
							});
						});
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			}
		},
		watch: {
			display (newVal) {
				this.selfDisplay = newVal;
			},
			selfDisplay (newVal) {
				this.$emit("changeDisplay", newVal);
				newVal && this.getData();
				!newVal && (this.tabData = []);
			}
		}
	}
</script>

<style>
</style>
